import React from 'react';
import {
  StatCardContainer,
  StatHeader,
  StatTitle,
  StatIconContainer,
  StatValue,
  StatLabel,
} from "./styles";

export default function StatCard({ title, value, label, icon }) {
  return (
    <StatCardContainer>
      {/* Cabeçalho do card: título à esquerda, ícone à direita */}
      <StatHeader>
        <StatTitle>{title}</StatTitle>
        {icon && (
          <StatIconContainer>
            {icon}
          </StatIconContainer>
        )}
      </StatHeader>

      {/* Valor centralizado */}
      <StatValue>{value}</StatValue>

      {/* Label abaixo do valor */}
      <StatLabel>{label}</StatLabel>
    </StatCardContainer>
  );
}
